import { Size } from '@bms2/shared';
import layout from './layout/layout.module.css';
import type { Gap } from './layout/Stack';

/**
 * T680: the one place a size or a gap becomes a class. Each control passes the classes of its own stylesheet; the map keeps the three
 * sizes in one order, and Medium is the unmarked size unless the stylesheet names it.
 */
export function sizeClassMap(classes: { small: string; large: string; medium?: string }): Record<Size, string> {
  return { [Size.Small]: classes.small, [Size.Medium]: classes.medium ?? '', [Size.Large]: classes.large };
}

/** The gap of Grid, Row and Stack: one class per step, from the layout stylesheet they share. */
export const gapClass: Record<Gap, string> = { tight: layout.gapTight!, regular: layout.gapRegular!, loose: layout.gapLoose! };
